import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../../redux/cartSlice";

export const ProductCard = ({ _id, url, title, price }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleAddToCart = () => {
        dispatch(addToCart({ _id, url, title, price }));
    };

    return (
        <div className="product-card" style={{
            border: "0px solid #FAFA",
            padding: "10px",
            margin: "5px",
            textAlign: "center"
        }}>

            <img 
                src={url} 
                alt={title}
                style={{ width: "100%", height: "500px", objectFit: "cover" }}
            />

            <p style={{ fontWeight: "bold" }}>
                {title ? title.slice(0, 18) : "No Title"}
            </p>

            <p style={{ color: "green", fontWeight: "bold" }}>
                ₹{price}
            </p>

            <button
                style={{
                    marginTop: "10px",
                    padding: "8px 15px",
                    backgroundColor: "#2874f0",
                    color: "white",
                    border: "none",
                    cursor: "pointer"
                }}
                onClick={() => navigate(`/order/${_id}`)}
            >
                Order Now
            </button>

            <button
                style={{
                    marginTop: "10px",
                    padding: "8px 15px",
                    backgroundColor: "green",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                    marginLeft: "10px"
                }}
                onClick={handleAddToCart}
            >
                Add to Cart
            </button>

        </div>
    );
};